export default "__VITE_ASSET__FsAugHzy__"